<template>
    <div class="content1">
        <div class="header">
            <div class="header-title">{{ bigScreenTitle }}</div>
            <div class="cur-time">
                <div class="operation">
                    <el-cascader style="width: 100%;" :clearable="true" v-model="searchAgentPath"
                        :props="formData.props" :options="cascade_options_direct" popper-append-to-body="false"
                        placement='left-start' size="small" />
                </div>
                <div class="time">
                    <el-date-picker class="inp" v-model="searchAllTime" value-format="YYYY-MM-DD" size="small"
                        type="daterange" unlink-panels :range-separator="$t('g.to')"
                        :start-placeholder="$t('g.start_date')" :end-placeholder="$t('g.end_date')"
                        :shortcuts="shortcuts">
                    </el-date-picker>
                </div>
            </div>
        </div>
        <div class="main">
            <div class="left">
                <div class="l1 card">
                    <div class="chart-title">
                        <div>{{ $t('bigScreen.total_ebox') }}</div>
                        <div>{{ $t('bigScreen.unit') }}:{{ $t('bigScreen.PCS') }}</div>
                    </div>
                    <div class="chart-content">
                        <echartONe :OnlineBox="leftData.OnlineBox" :OfflineBox="leftData.OfflineBox"
                            :NoReleaseBox="leftData.NoReleaseBox"></echartONe>
                    </div>
                </div>
                <div class="l2 card">
                    <div class="chart-title">
                        <div>{{ $t('bigScreen.total_battary') }}</div>
                        <div>{{ $t('bigScreen.unit') }}:{{ $t('bigScreen.PCS') }}</div>
                    </div>
                    <div class="chart-content">
                        <leftTwoEchart :InDevCount="leftData.InDevCount" :InIdleCount="leftData.InIdleCount"
                            :InManCount="leftData.InManCount" :TatolCount="leftData.TatolCount"></leftTwoEchart>
                    </div>
                </div>
                <div class="l3 card">
                    <div class="chart-title">
                        <div>{{ $t('bigScreen.total_emotor') }}</div>
                        <div>{{ $t('bigScreen.unit') }}:{{ $t('bigScreen.PCS') }}</div>
                    </div>
                    <div class="chart-content">
                        <echartThree></echartThree>
                    </div>
                </div>
            </div>
            <div class="center">
                <div class="map" id="map">
                    <div id="bigScreenMap" style="width:100%;height: 100%;">
                    </div>
                    <div :class="enLang ? 'en-select' : 'select'">
                        <div>
                            <el-radio v-model="mapSearch.type" label="all" :value="0">{{ $t('bigScreen.all')
                            }}</el-radio>
                        </div>
                        <div>
                            <el-radio v-model="mapSearch.type" label="ebox" :value="1">{{ $t('bigScreen.ebox')
                            }}</el-radio>
                        </div>
                        <div>
                            <el-radio v-model="mapSearch.type" label="cbox" :value="2">{{ $t('bigScreen.cbox')
                            }}</el-radio>
                        </div>
                        <div>
                            <el-radio v-model="mapSearch.type" label="all" :value="5">{{ $t('bigScreen.emotor')
                            }}</el-radio>
                        </div>
                        <div>
                            <el-switch v-model="mapSearch.online" active-color="#13ce66">
                            </el-switch>
                            <span class="switch-txt switch-txt-online">{{ $t('bigScreen.online') }}</span>
                        </div>

                        <div>
                            <el-switch v-model="mapSearch.offline" active-color="#ff4949">
                            </el-switch>
                            <span class="switch-txt switch-txt-offline">{{ $t('bigScreen.offline') }}</span>
                        </div>

                    </div>

                    <div class="info-window" v-if="formData.showMapDetails">
                        <div class="title">{{ formData.mapCur.name }}</div>
                        <div>在线状态:{{ formData.mapCur.status }}</div>
                        <div>代理商:{{ formData.mapCur.agentCode }}</div>
                        <div>站点名称:{{ formData.mapCur.siteName }}</div>
                        <div>设备编号:{{ formData.mapCur.devId }}</div>
                        <div>设备地址:{{ formData.mapCur.address }}</div>
                        <div class="close" @click="func.hideMapDetails">X</div>
                    </div>
                </div>
                <div class="order">
                    <div class="item">
                        <span>{{ $t('bigScreen.exBatId') }}</span>
                        <span>{{ $t('bill.nickname') }}</span>
                        <span>{{ $t('bill.status') }}</span>
                        <span>{{ $t('g.create_at') }}</span>
                    </div>
                    <vue3-seamless-scroll :list="exchangeBatData" class="scroll" :step="0.5" :hover="true">

                        <div class="item" v-for="(item, index) in exchangeBatData" :key="item.Id">
                            <span>{{ item.OrderSn }}</span>
                            <span>{{ item.UserInfo?.Nickname }}</span>
                            <span :style="item.Status == 0 ? 'color:#ea9aa6' : 'color:#06c7ec'">{{
                                exchangeBatStatus[item.Status]
                                }}</span>
                            <span>{{ item.CreatedAtStr }}</span>
                        </div>
                    </vue3-seamless-scroll>
                </div>
            </div>
            <div class="right">
                <div class="r1">
                    <div class="chart-title">
                        <div class="t">{{ $t('bigScreen.total_revenue') }}</div>
                        <div class="t" style="width:1.5rem">{{ $t('bigScreen.daily_earnings') }}</div>
                    </div>
                    <div class="chart-content">
                        <div>
                            <div>{{ $t('bigScreen.amount_received') }}</div>
                            <div>{{ (incomeData.allEarnings * FakeCoef).toFixed(2) }}</div>
                        </div>
                        <div>
                            <div>{{ $t('bigScreen.today_income') }}</div>
                            <div>{{ (incomeData.todayEarnings * FakeCoef).toFixed(2) }}</div>
                        </div>
                        <div>
                            <div>{{ $t('bigScreen.refund_amount') }}</div>
                            <div>{{ (incomeData.allRefund * FakeCoef).toFixed(2) }}</div>
                        </div>
                        <div>
                            <div>{{ $t('bigScreen.today_refund') }}</div>
                            <div>{{ (incomeData.todayRefund * FakeCoef).toFixed(2) }}</div>
                        </div>
                    </div>
                </div>
                <div class="r2">
                    <div class="chart-title">
                        <div class="t">{{ $t('bigScreen.user_data') }}</div>
                        <!-- <div class="time">
                            <el-date-picker class="inp" v-model="formData.valTime2" value-format="YYYY-MM-DD"
                                size="small" type="daterange" unlink-panels :range-separator="$t('g.to')"
                                :start-placeholder="$t('g.start_date')" :end-placeholder="$t('g.end_date')"
                                :shortcuts="shortcuts">
                            </el-date-picker>
                        </div> -->
                    </div>
                    <div class="chart-content">
                        <div>
                            <div>{{ $t('bigScreen.registered_users') }}</div>
                            <div>{{ (userData.totalUser * FakeCoef).toFixed(0) }}</div>
                        </div>
                        <div>
                            <div>{{ $t('bigScreen.valid_users') }}</div>
                            <div>{{ (userData.validUser * FakeCoef).toFixed(0) }}</div>
                        </div>
                        <div>
                            <div>{{ $t('bigScreen.added_users') }}</div>
                            <div>{{ (userData.newUser * FakeCoef).toFixed(0) }}</div>
                        </div>
                    </div>
                </div>
                <div class="r3">
                    <div class="chart-title">
                        <div class="t">{{ $t('bigScreen.operation_data') }}</div>
                        <!-- <div class="time">
                            <el-date-picker class="inp" v-model="formData.valTime2" value-format="YYYY-MM-DD"
                                size="small" type="daterange" unlink-panels :range-separator="$t('g.to')"
                                :start-placeholder="$t('g.start_date')" :end-placeholder="$t('g.end_date')"
                                :shortcuts="shortcuts">
                            </el-date-picker>
                        </div> -->
                    </div>
                    <div class="chart-content">
                        <div>
                            <div>{{ $t('bigScreen.BAT_swapping') }}</div>
                            <div>{{ (operateData.ExchangeOrderTotal * FakeCoef).toFixed(0) }}</div>
                        </div>
                        <div>
                            <div>{{ $t('bigScreen.total_BAT_number') }}</div>
                            <div>{{ (leftData.TatolCount * FakeCoef).toFixed(0) }}</div>
                        </div>
                        <div>
                            <div>{{ $t('bigScreen.total_vehicle') }}</div>
                            <div>{{ (operateData.CarTotal * FakeCoef).toFixed(0) }}</div>
                        </div>
                        <div>
                            <div>{{ $t('bigScreen.success_rate_swapping') }}</div>
                            <div>{{ operateData.ExchangeSuccessRate }}</div>
                        </div>
                        <div>
                            <div>{{ $t('bigScreen.battery_rentals') }}</div>
                            <div>{{ (leftData.InManCount * FakeCoef).toFixed(0) }}</div>
                        </div>
                        <div>
                            <div>{{ $t('bigScreen.vehicle_rentals') }}</div>
                            <div>{{ (operateData.CarRentTotal * FakeCoef).toFixed(0) }}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script setup>
import { getEqs } from '@/data/Equipments'
import { reactive, onMounted, VueElement, nextTick, ref, onBeforeUnmount, watch } from 'vue'
import '../../assets/bigScreen/flexible'
import { toDay } from '@/common/func'
import i18n from '@/data/i18n/index'
import axios from "axios";
import { ElMessage, dayjs } from "element-plus";
import echartONe from '@/views/bigScreen/leftOneEchart'
import echartThree from '@/views/bigScreen/leftThreeEchart'
import { shortcuts2, shortcuts, updateOperators, operatorList, cascade_options_direct } from "@/data/default";
import { user } from '@/data/token'
import leftTwoEchart from '@/views/bigScreen/leftTwoEchart'
import { Vue3SeamlessScroll } from "vue3-seamless-scroll";
import storage from '@/common/storage'
const t = i18n.global.t
const tableData = []


const formData = reactive({
    props: {
        children: "Children",
        label: "Name",
        value: "Id",
        emitPath: false,
        checkStrictly: true
    },
    tableData,
    showMapDetails: false,
    mapCur: {},
})
const enLang = ref(false)
let searchAllTime = ref('')
let searchAgentPath = ref('')
let exchangeBatData = ref([])
let FakeCoef = ref(1)
if (user.FakeCoef >= 1) {
    FakeCoef.value = user.FakeCoef
}

let bigScreenTitle = ref(t('bigScreen.title'))
if (user.AgentCode == 'HDDT') {
    bigScreenTitle.value = user.name + t('bigScreen.title2')
} else {
    bigScreenTitle.value = t('bigScreen.title')
}
const exchangeBatStatus = ref([t('g.Failed'), t('g.Success'), t('chart.order_statuses.doing')])
const search = reactive({
    allTime: '',
    AgentCode: ''
})
const mapSearch = reactive({
    type: 0,//0 所有 1换电柜  2充电柜 3 两轮充电柜 4 厢桩充电柜 5 汽车充电柜
    online: true,
    offline: true,
})
let leftData = reactive({
    InDevCount: 0,
    InIdleCount: 0,
    InManCount: 0,
    OfflineCount: 0,
    OnlineCount: 0,
    TatolCount: 0,
    OnlineBox: 0,
    OfflineBox: 0,
    NoReleaseBox: 0,
})
let map = {}
let markerCluster = null
const incomeData = reactive({
    allEarnings: 0,
    allRefund: 0,
    todayEarnings: 0,
    todayRefund: 0,
})
const userData = reactive({
    newUser: 0,
    totalUser: 0,
    validUser: 0,
})
const operateData = reactive({
    ExchangeOrderTotal: 0,
    ExchangeOrderSuccess: 0,
    ExchangeSuccessRate: 0,
    CarTotal: 0,
    CarRentTotal: 0,
})
onMounted(async () => {
    if (storage.get('locale') == 'En') {
        enLang.value = true
    }
    func.getDevStat()
    func.getMapData()
    func.getIncome()
    func.getUserData()
    func.getOperateData()
    func.getExchangeBatOrder()
}
)
watch(searchAllTime, () => {
    func.getOperateData()
    func.getUserData()
})
watch(searchAgentPath, () => {
    func.getOperateData()
    func.getUserData()
    func.getDevStat()
    func.getIncome()
    func.getExchangeBatOrder()
    func.mapDataFiter()
})
watch(mapSearch, () => {
    func.mapDataFiter()

})
const func = {
    mapDataFiter() {
        // console.log(JSON.stringify(searchAgentPath.value), 23802);

        let arr = []
        arr = formData.data.filter((item) => {


            if (searchAgentPath.value && item.CodePath.indexOf(searchAgentPath.value) == -1) {
                return false
            }
            if (mapSearch.type !== 0 && mapSearch.type != item.type) {
                return false
            }
            if (mapSearch.online && mapSearch.offline) {
                return true
            } else if (mapSearch.online && !mapSearch.offline) {
                if (item.status === t('device.statuses.online')) {
                    return true
                }
            } else if (!mapSearch.online && mapSearch.offline) {
                if (item.status === t('device.statuses.offline')) {
                    return true
                }
            } else if (!mapSearch.online && !mapSearch.offline) {
                return false
            }
        })
        let markerList = []
        const onMarkerClick = function (e) {
            // console.log(JSON.stringify(e.target.w.extData));
            formData.mapCur = e.target.w.extData.item
            formData.showMapDetails = true
        };
        for (const item of arr) {
            // console.log(JSON.stringify(item));
            const marker = new AMap.Marker({
                position: [item.lng, item.lat],
                clickable: true,
                extData: {
                    item: item
                },
                icon: func.getMarkerIcon(item)
            })
            marker.on("click", onMarkerClick); //绑定click事件
            markerList.push(marker)
        }
        // let markerCluster = new AMap.MarkerClusterer(map, markerList, styles)
        // map.set(markerList);
        if (FakeCoef.value > 1) {
            // console.log(markerList, 28302);
            // map.remove()
            map.clearMap()
            map.add(markerList);//非聚合
            // map.setMap(markerList);
        } else {
            markerCluster.setMarkers(markerList)
        }

        // console.log(map, 28302);
    },
    async getMapData() {
        formData.tableData = tableData
        const AMap = window.AMap
        let center = [11.2, 11.2]
        map = new AMap.Map('bigScreenMap', {
            zoom: 1, // 设置地图缩放级别
            // pitch: 890, // 设置地图俯仰角
            center: [116.397428, 39.90923],//设置地图中心点坐标
            resizeEnable: true,
            // mapStyle: 'amap://styles/f9db5bb4478d355b9c1fc70c756671c8',
            mapStyle: 'amap://styles/blue',
            features: ['bg', 'road'],
        });

        let allEQs = await getEqs()
        formData.data = allEQs
        // console.log(formData.data);
        let markerList = []
        const onMarkerClick = function (e) {
            console.log(JSON.stringify(e.target.w.extData));
            formData.mapCur = e.target.w.extData.item
            formData.showMapDetails = true
        };
        for (const item of formData.data) {
            const marker = new AMap.Marker({
                position: [item.lng, item.lat],
                clickable: true,
                extData: {
                    item: item
                },
                icon: func.getMarkerIcon(item)
            })
            marker.on("click", onMarkerClick); //绑定click事件
            markerList.push(marker)
        }

        if (FakeCoef.value > 1) {
            map.add(markerList);//非聚合
        } else {
            markerCluster = new AMap.MarkerClusterer(map, markerList, {
                gridSize: 50,
            })//聚合
        }

    },
    hideMapDetails() {
        console.log(JSON.stringify(208302));

        formData.showMapDetails = false
    },
    getMarkerIcon(item) {
        const AMap = window.AMap
        let name = ""
        let status = "online"
        if (item.status != t('device.statuses.online')) status = "offline";
        if (item.type == 1) {
            name = "box"
        } else if (item.type == 2) {
            name = "battery"
        } else if (item.type == 3) {
            name = "pile"
        } else {
            name = "cpbox"
        }
        const image = require('@/assets/img/' + name + '-' + status + '.png')
        const icon = new AMap.Icon({
            size: new AMap.Size(32, 41),
            image,
        });
        return icon
    },
    async getDevStat() {
        let params = {}
        if (searchAgentPath) {
            params.CodePathID = searchAgentPath.value
        }
        let res = await axios.get('/admin/battery/getstat', {
            params
        })
        if (res) {
            // leftData = res
            // leftData = { ...res }
            leftData.InDevCount = (res.InDevCount * FakeCoef.value).toFixed(0)
            leftData.InIdleCount = (res.InIdleCount * FakeCoef.value).toFixed(0)
            leftData.InManCount = (res.InManCount * FakeCoef.value).toFixed(0)
            leftData.OnlineBox = (res.OnlineBox * FakeCoef.value).toFixed(0)
            leftData.OfflineBox = (res.OfflineBox * FakeCoef.value).toFixed(0)
            leftData.TatolCount = (res.TatolCount * FakeCoef.value).toFixed(0)
            leftData.NoReleaseBox = (res.NoReleaseBox * FakeCoef.value).toFixed(0)

        }
        console.log(JSON.stringify(leftData), 1820);

    },
    async getIncome() {
        let params = {}
        if (searchAgentPath) {
            params.CodePathID = searchAgentPath.value
        }
        let res = await axios.get('/admin/homescreen/getincome', {
            params
        })
        if (res) {
            incomeData.allEarnings = res.RealIncome
            incomeData.allRefund = res.RefundTotal
            incomeData.todayEarnings = res.TodayRealIncome
            incomeData.todayRefund = res.TodayRefund
        }

    },
    async getUserData() {
        let params = {}
        if (searchAgentPath) {
            params.CodePathID = searchAgentPath.value
        }
        if (searchAllTime.value) {
            params.startAt = dayjs(searchAllTime.value[0] + ' 00:00:01').unix()
            params.endAt = dayjs(searchAllTime.value[1] + ' 23:59:59').unix()
        }
        let res = await axios.get('/admin/homescreen/getusernum', {
            params
        })
        if (res) {
            userData.newUser = res.newUser
            userData.totalUser = res.totalUser
            userData.validUser = res.validUser
        }
    },
    async getOperateData() {
        let params = {}
        if (searchAgentPath) {
            params.CodePathID = searchAgentPath.value
        }
        if (searchAllTime.value) {
            params.startAt = dayjs(searchAllTime.value[0] + ' 00:00:01').unix()
            params.endAt = dayjs(searchAllTime.value[1] + ' 23:59:59').unix()
        }
        let res = await axios.get('/admin/homescreen/operationdata', {
            params
        })
        if (res) {
            operateData.ExchangeOrderTotal = res.ExchangeOrderTotal
            operateData.ExchangeOrderSuccess = res.ExchangeOrderSuccess
            operateData.ExchangeSuccessRate = res.ExchangeSuccessRate
            operateData.CarTotal = res.CarTotal
            operateData.CarRentTotal = res.CarRentTotal
        }
    },
    fontSize(res) {
        const clientWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
        if (!clientWidth) return;
        let fontSize = clientWidth / 1920;
        return res * fontSize;
    },

    async getExchangeBatOrder() {
        let params = {}
        if (searchAgentPath) {
            params.agentcode = searchAgentPath.value
        }
        params.isHomeData = 1
        params.IsStartWith = 1
        let res = await axios.get('/admin/order/exchange', {
            params
        })
        if (res) {
            res.forEach((item) => {
                item.CreatedAtStr = dayjs.unix(item.CreatedAt).format('YYYY-MM-DD HH:mm:ss')
            })
            exchangeBatData = res
        }
    },
}
onBeforeUnmount(() => {
    // 销毁地图，防止卡顿
    map.destroy()
})




</script>
<style lang="scss" scoped>
.content1 {
    width: 100vw;
    height: 100vh;
    background-image: url("../../assets/bigScreen/BD_BG.jpg");
    background-size: 100% 100%;
    background-repeat: no-repeat;
    display: flex;
    flex-direction: column;
    $card-title-font-size: .25rem;

    >.header {
        width: 100%;
        background-size: 100% 1.5rem;
        background-image: url("../../assets/bigScreen/BD_top.png");
        background-repeat: no-repeat;
        position: relative;
        height: 1.25rem;
        line-height: 1.25rem;

        .header-title {
            height: 1rem;
            line-height: 1rem;
            color: aliceblue;
            font-size: .425rem;
        }

        .cur-time {
            color: aliceblue;
            font-size: .15rem;
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            display: flex;
            width: 100%;
            height: .85rem;
            // background-color: red;
            // padding: 0 .25rem;
            justify-content: space-between;
            // // background-color: red;
            // // align-items: center;
            align-items: center;

            >.operation {
                margin-left: 0.25rem;

                // margin-top: -0.18rem;

                .inp2 {
                    width: 2.25rem;
                }

                :deep(.el-select .el-input) {
                    --el-input-bg-color: #092141;
                    // width: 60%;
                    --el-input-placeholder-color: #e1eafb;
                    --el-input-border-color: #9ca7c2;
                    height: .3rem;
                    font-size: .15rem;


                }

                // :deep(.el-select .el-input__inner) {
                //     font-size: .1rem;
                // }

                :deep(.el-select .el-select__wrapper) {
                    background-color: #092141;
                    color: #f7f0f0;
                }

                :deep(.el-select .el-el-select__suffix) {
                    color: #f7f0f0;
                }

                :deep(.el-select .el-select__placeholder) {
                    color: #f7f0f0;
                }


            }

            :deep(.time .el-date-editor) {
                --el-input-bg-color: #092141;
                // --el-input-placeholder-color: #e1eafb;
                --el-date-editor-monthrange-width: 2.5rem;
                --el-date-editor-daterange-width: 2.9rem;
                --el-date-editor-datetimerange-width: 2.5rem;
                font-size: 1.125rem;
                height: .4rem;
                line-height: .375rem;

                .el-range-separator {
                    color: #e1eafb;
                    font-size: .18rem;

                }

                .el-icon {
                    color: #e1eafb;
                    font-size: .225rem;
                }
            }

            :deep(.time .el-date-editor .el-range-input) {
                // --el-input-placeholder-color: #ffffff;
                width: 45%;
                color: #7faafb;
                font-size: .18rem;

                &::placeholder {
                    color: #e1eafb !important;
                    font-size: .18rem;
                }
            }

            .time {

                margin-right: 0.25rem;
                // margin-top: -0.18rem;


            }
        }
    }

    >.main {
        flex: 8;
        display: flex;
        padding: .05rem 0.1rem;


        >.left {
            flex: 1;
            display: flex;
            flex-direction: column;

            >.l1 {
                .chart-content {
                    width: 100%;
                }
            }

            .r1,
            .r2,
            .r3 {
                font-size: .175rem;
            }
        }

        >.center {
            flex: 1.8;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;

            >.map {
                width: 90%;
                flex: 3;
                position: relative;

                // background-color: pink;
                .en-select,
                .select {
                    position: absolute;
                    top: 0;
                    right: 0;
                    left: 0;
                    // bottom: 0;
                    background-color: #6c7e95;
                    color: #fff;
                    padding: .0rem 0;
                    border-radius: .0625rem;
                    // transform: translate(0, -50%);
                    display: flex;
                    flex-wrap: wrap;
                    justify-content: space-around;
                    align-items: center;
                    height: 0.6rem;
                    // line-height: 1.6rem;

                    >div {
                        // width: 2.5rem;
                        text-align: left;
                        display: flex;
                        align-items: center;
                        // background-color: red;
                        height: 0.6rem;

                        // background-color: red;
                        >.switch-txt {
                            font-size: .225rem;
                        }
                    }

                    :deep(.el-radio .el-radio__label) {
                        color: #fff;
                        font-size: .225rem;
                    }

                    :deep(.el-radio .el-radio__inner) {
                        width: .325rem;
                        height: .325rem;
                    }

                    :deep(.is-checked .el-radio__label) {
                        color: #409eff;
                    }

                    :deep(.el-switch .el-switch__core) {
                        // background-color: #fff;
                        height: .3rem;
                        width: 0.65rem;
                        min-width: 0.65rem;

                        .el-switch__action {
                            height: .3rem;
                            width: .3rem;
                        }
                    }

                    :deep(.el-switch.is-checked .el-switch__core .el-switch__action) {
                        left: calc(100% - .3rem);
                    }

                    .switch-txt {
                        margin: 0 .15rem;
                    }
                }

                // .select {
                //     >div {
                //         width: 1.4rem;
                //     }
                // }

                .info-window {
                    position: absolute;
                    top: 1.25rem;
                    left: 2%;
                    z-index: 100;
                    color: black;
                    background-color: #fff;
                    padding: .125rem .25rem;
                    text-align: left;
                    border-radius: .125rem;
                    font-size: .3rem;

                    >div {
                        margin-bottom: .0625rem;
                    }

                    >.title {
                        font-size: .3125rem;
                        text-align: center;
                    }

                    >.close {
                        position: absolute;
                        top: .125rem;
                        right: .125rem;
                        font-size: .25rem;

                        &:hover {
                            cursor: pointer;
                        }
                    }
                }
            }

            >.order {
                width: 90%;
                flex: 1.3;
                border: .0125rem solid #5d7da8;
                position: relative;
                height: 1.25rem;
                // height: 100%;
                margin: .125rem 0;
                background-color: #000d20;

                >.scroll {
                    position: absolute;
                    top: .475rem;
                    overflow: hidden;
                    color: #fff;
                    height: calc(100% - .475rem);
                    width: 100%;
                    // display: flex;
                    // justify-content: space-around;
                    // background-color: red;
                    // z-index: 100;


                }

                .item {
                    display: flex;
                    justify-content: space-around;
                    width: 100%;
                    color: #fff;
                    border: .0125rem solid #3362a0;
                    font-size: .275rem;

                    &:hover {
                        background-color: #1b4078;
                        color: #fff;
                    }

                    >span {
                        // flex: 1;
                        height: .475rem;
                        line-height: .475rem;


                    }

                    >span:first-child {
                        flex: 2;
                    }

                    >span:nth-child(2) {
                        flex: 1;
                    }

                    >span:nth-child(3) {
                        flex: 1;
                    }

                    >span:last-child {
                        flex: 2;
                    }

                }

                >.item:first-child {
                    background-color: #1e3f70;
                    color: #e2e9ed;

                    span:nth-child(-n+3) {
                        border-right: .0125rem solid #3362a0;
                    }

                }



            }
        }

        >.right {
            flex: 1;
            display: flex;
            flex-direction: column;
            color: #f9f4f4;

            .r1,
            .r2,
            .r3 {
                flex: 1;
                margin-bottom: .125rem;
                display: flex;
                flex-direction: column;

                >.chart-title {
                    height: .6rem;
                    color: #e2e9ed;
                    text-align: left;
                    padding-left: .5rem;
                    line-height: .6rem;

                    font-size: $card-title-font-size;
                    display: flex;
                    justify-content: space-between;
                    padding: 0 .1875rem;

                    >.t {
                        width: 1.55rem;
                        border: .025rem solid #026a81;
                        border-radius: .0625rem;
                        box-shadow: #7bc4d6 .0225rem .0225rem .025rem;
                        text-align: center;
                    }

                    >.time {
                        height: .375rem;
                        line-height: .35rem;
                    }
                }

                >.chart-content {
                    flex: 4;
                    font-size: .25rem;
                }
            }

            .r1 {
                display: flex;

                .chart-content {
                    display: grid;
                    grid-template-columns: 1fr 1fr;
                    row-gap: .25rem;
                    column-gap: .35rem;
                    padding: .25rem .125rem .125rem;

                    >div {
                        display: flex;
                        border-top: .0125rem solid #bdc4cb;
                        border-bottom: .0125rem solid #bdc4cb;
                        font-size: .25rem;
                        color: #8ddbff;
                        align-items: center;

                        >div {
                            flex: 1;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            width: 100%;
                            height: 100%;
                        }

                        >div:first-child {
                            flex: 1;
                            min-width: 1.2rem;
                            background-color: #e3ecf4;
                            color: #005fb0;
                        }

                        >div:last-child {
                            flex: 2;
                            background-color: #5d7da8;
                            color: #f9f4f4;
                        }
                    }
                }
            }

            .r2 {
                .chart-content {
                    display: grid;
                    grid-template-columns: 1fr 1fr 1fr;
                    row-gap: .3rem;
                    // column-gap: .1rem;
                    padding: .125rem 0 0;

                    >div {
                        place-self: center;
                        display: flex;
                        height: 90%;
                        flex-direction: column;
                        justify-content: space-around;
                        align-items: center;

                        >div {
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            width: 100%;
                            padding: 0 .0625rem;
                        }

                        >div:first-child {
                            flex: 1;
                            min-width: 1.2rem;
                            background-color: #f9fafa;
                            color: #024784;
                            border-radius: .0625rem .0625rem 0 0;
                        }

                        >div:last-child {
                            flex: 1.3;
                            background-color: #94b9e8;
                            color: #ffffff;
                        }
                    }
                }
            }

            .r3 {
                .chart-content {
                    display: grid;
                    grid-template-columns: 1fr 1fr 1fr;
                    row-gap: .1rem;
                    column-gap: .1rem;
                    padding: .125rem .125rem 0px;

                    >div {
                        border: .0125rem solid #5d7da8;
                        box-shadow: #a4c1e4 .0125rem .0125rem .025rem;
                        display: flex;
                        flex-direction: column;
                        justify-content: center;
                        align-items: center;

                        >div {
                            flex: 1;
                            display: flex;
                            align-items: center;
                        }

                        // >div:last-child {
                        //     color: rgb(217, 145, 145);
                        // }
                    }

                }
            }
        }

        .card {
            flex: 1;
            margin-bottom: .125rem;
            display: flex;
            flex-direction: column;
            background-image: url("../../assets/bigScreen/BD_K_bg.png");
            background-repeat: no-repeat;
            background-size: 100% 100%;

            >.chart-title {
                height: .6rem;
                background-image: url("../../assets/bigScreen/BD_title_bg.png");
                background-repeat: no-repeat;
                background-size: 100% 100%;
                color: #e2e9ed;
                text-align: left;
                padding-left: .5rem;
                padding-right: .39rem;
                font-size: $card-title-font-size;
                line-height: .6rem;
                display: flex;
                justify-content: space-between;

                >div {
                    font-size: $card-title-font-size;
                }
            }

            >.chart-content {
                flex: 4;
                font-size: .275rem;
            }
        }
    }


    :deep(.amap-logo) {
        position: fixed !important;
        opacity: 0 !important;
    }

    :deep(.amap-copyright) {
        opacity: 0;
    }

    :deep(.operation .el-cascader .el-input__wrapper) {

        background-color: #092141 !important;
        color: #fff !important;

        .el-input__inner {
            color: #7faafb;
            width: 2.5rem;
            height: .375rem;
            line-height: .375rem;
            font-size: .2rem;

            &::placeholder {
                color: #e1eafb;
            }
        }
    }
}
</style>
<!-- 



-->